module.exports = __webpack_public_path__ + "media/images/ohmyhome-b04a2e7c3f7b97834a981c294277c0f4.png";